export const new_pass_text1 = 'Let’s create your account to get started!';
export const new_pass_btn = 'Submit';
export const set_new_pass = 'Set New Password';
export const label_text = {
  password: 'Password',
  confirmPassword: 'Confirm Password',
};

export const placeholder = {
  password: 'Enter Password',
  confirmPassword: 'Enter Confirm Password',
};

export const name = {
  password: 'password',
  confirmPassword: 'confirmPassword',
};

export const validation = {
  password_required: 'Password is required',
  confirmPassword_required: 'Confirm password is required',
  confirmPassword_match: 'Confirm password must match with the password',
};
